<template>
  <div class="process-select-person">
    <el-dialog class="process-info-person-dialog" title="通知用户名单" :visible.sync="dialogVisible" :before-close="cancel" center @open="open()" :close-on-click-modal="false" append-to-body>
      <div class="selected">
        <select-person :remoteSearch="true" :treeData="allData" :select="select" ref="select" :isRadio="'multiple'"></select-person>
      </div>
      <div class="buttons">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectPerson from '../../system/select-person'

export default {
  name: 'ProcessSelectCustom',
  props: ['dialogVisible', 'allData', 'candidates'],
  components: {
    SelectPerson
  },
  data () {
    return {
      select: []
    }
  },
  methods: {
    open () {
      this.select = this.candidates || []
    },
    save () {
      let select = []
      this.$refs.select.getSelectedList().forEach(m => {
        select.push({
          'targetId': m.id,
          'name': m.name,
          'type': m.type,
          'defaultValue': false
        })
      })
      this.$emit('saveSelectCustom', {
        'candidates': select
      })
    },
    cancel () {
      this.$emit('closeCustomDialog')
    }
  }

}
</script>

<style lang="scss">
  .process-info-person-dialog {
    .el-dialog {
      height: 475px;
      width: 646px;
      div.el-dialog__header {
        height: 34px;
      }
      div.el-dialog__body {
        height: 100%;
        width: 100%;
        padding: 0 0 0 0;
        .selected {
          margin-top: 19px;
        }
        form.el-form {
          margin-top: 30px;
          padding-left: 61px;
          .el-form-item {
            margin-right: 17px;
            .el-form-item__label {
              font-size: 14px;
            }
            .explain {
              font-size: 12px;
              color: #B3B3B3;
            }
            .el-form-item__content {
              .el-input {
                width: 162px;
              }
              height: 28px;
              .el-select {
                width: 100%;
                height: 100%;
              }
            }
          }
          > div {
            margin-top: 0px;
            padding-left: 0px;
          }
        }
        .buttons {
          text-align: center;
          margin-top: 25px;
          button {
            width: 104px;
            height: 30px;
            span {
              font-size: 16px;
            }
            &:first-child {
              margin-right: 35px;
            }
          }

        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/process/design/process-dialog-select-custom.vue